import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import logo from '../../assets/img/reactlogo.png';
import logoSmall from '../../assets/img/logoSmall.png';

function AdminNav({ onToggleSidebar }) {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.data);
  const handleLogout = async () => {
    try {
      //const response = await axios.post('/logout');
      const response = await axios.post('/clear-data');
      const { status, message } = response.data;
      if (status) {
        sessionStorage.removeItem("admin_notice_shown");
        localStorage.removeItem("deviceId");
        localStorage.removeItem("token");
        //navigate('/login');
        window.location.href = "/login";
      }
      else {
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  }
  return (
    <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <Link className="navbar-brand brand-logo me-5" to="/admin/dashboard">
          <img src={logo} className="me-2" alt="logo" />
        </Link>
        <Link className="navbar-brand brand-logo-mini" to="/admin/dashboard">
          <img src={logoSmall} alt="logo" />
        </Link>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
        <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
          <span className="ti-view-list"></span>
        </button>
        <ul className="navbar-nav mr-lg-2">
          <li className="nav-item nav-search d-none d-lg-block">
            <div className="input-group">
              <div className="input-group-prepend hover-cursor" id="navbar-search-icon">
                <span className="input-group-text" id="search">
                  <i className="ti-search"></i>
                </span>
              </div>
              <input type="text" className="form-control" id="navbar-search-input" placeholder="Search now"
                aria-label="search" aria-describedby="search" />
            </div>
          </li>
        </ul>
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item dropdown">
            <div className="headingName">
              <p>Welcome: {currentUser?.name}</p>
            </div>
          </li>
          <li className="nav-item nav-profile dropdown">
            <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" id="profileDropdown">
              <img src={currentUser && currentUser.profile_picture ? currentUser.profile_picture : logoSmall} alt="profile" />
            </a>
            <div className="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
              <Link className="dropdown-item" to="/admin/settings">
                <i className="ti-settings text-primary"></i>
                Settings
              </Link>
              {
                currentUser && currentUser.user_type == "admin" && (
                  <Link className="dropdown-item" to="/admin/appSettings">
                    <i className="ti-settings text-primary"></i>
                    App Settings
                  </Link>
                )
              }
              <a className="dropdown-item" onClick={handleLogout}>
                <i className="ti-power-off text-primary"></i>
                Logout
              </a>
            </div>
          </li>
        </ul>
        <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
          data-toggle="offcanvas" onClick={onToggleSidebar}>
          <span className="ti-view-list"></span>
        </button>
      </div>
    </nav>
  );
}

export default AdminNav;
